/**
 * Inline short-dated suffix for a zone label, e.g. " (SD 12)".
 * Returns "" when the zone holds no short-dated stock of the picked product.
 * Used in plain-text contexts (the compact zone preview and Select option
 * labels) where a styled badge cannot be rendered. `shortDatedQuantity` is
 * populated by the zonesWithProduct query.
 */
export function zoneSdSuffix(zone) {
  const qty = zone?.shortDatedQuantity;
  return qty > 0 ? ` (SD ${qty})` : '';
}

/**
 * Inline quarantine marker for a zone label, e.g. " (Quarantine)". Only return
 * sales orders ever see quarantine zones offered for picking, so the marker tells
 * the picker why an otherwise unpickable zone is on the list. `zoneType` is
 * populated by the zonesWithProduct query.
 */
export function zoneQuarantineSuffix(zone) {
  return zone?.zoneType === 'quarantine' ? ' (Quarantine)' : '';
}

/**
 * Which ZoneInventoryBalance bucket a pick draws from. Quarantine zones hold their
 * units in `quarantined`; destruction orders draw from `destroyed`. Mirrors the
 * bucket the server picks in pickUnserializedSalesOrder.
 */
export function zonePickBucket(zone, { isDestructionOrder = false } = {}) {
  if (isDestructionOrder) return 'destroyed';
  return zone?.zoneType === 'quarantine' ? 'quarantined' : 'stocked';
}
